import { createServiceToken } from '@/app/di';
import type { PaymentPort } from './payment.port';

export const PAYMENT_PORT = createServiceToken<PaymentPort>('PaymentPort');
